import { moneyToNumber } from "../utils/money";
import { calcTotalCost } from "../utils/calcCost";

const calcOptionTotal = ({ jobItems, discounts, fees, sales_tax, job, prices }) => {
  let grandTotal;
  let salesTax = 0;
  let ttlCostMaterials = 0;
  let ttlCostLabor = 0;
  let ttlCostTax = 0;
  let priceAdjs = [];
  const priceSheet = job?.price_sheets_id;
  const laborPrices = prices?.laborPrices?.filter(
    (price) => parseInt(price.price_sheets_id) === parseInt(priceSheet)
  )[0];
  const laborPrice = Number(laborPrices?.labor_cost);
  
  // Calculate job items total
  const jobsTotal = jobItems?.reduce((optionTtl, item) => {
    let {
      base_price,
      custom_price,
      extras_price,
      quantity,
      cost_retail,
      cost_materials,
      cost_labor,
    } = item;
    // make sure given values are numbers
    base_price = moneyToNumber(base_price);
    custom_price = moneyToNumber(custom_price);
    extras_price = moneyToNumber(extras_price);
    const costRetail = moneyToNumber(cost_retail);
    const costMaterials = moneyToNumber(cost_materials);
    // Calculate price
    const ttl = custom_price ? custom_price : base_price + extras_price;
    // Calculate costs
    const { tax, laborTotalCost } = calcTotalCost(
      costRetail,
      costMaterials,
      cost_labor,
      laborPrice,
      ttl
    );
    ttlCostTax = ttlCostTax + tax * quantity;
    ttlCostMaterials = ttlCostMaterials + costMaterials * quantity;
    ttlCostLabor = ttlCostLabor + laborTotalCost * quantity;
    // Return total price
    return optionTtl + ttl * quantity;
  }, 0);

  // Add price adjustments
  let ttlPriceAdj = 0;
  ttlPriceAdj = discounts?.reduce((ttlPriceAdj, discount) => {
    let { usePA, amount, modifier, description } = discount;
    amount = Number(amount);
    let priceAdj = 0;
    if (usePA) {
      // modifier 1 is % and 2 is flat amount
      priceAdj = modifier === 1 ? (amount / 100) * jobsTotal : amount;
    }
    priceAdjs.push({ description, priceAdj });
    return ttlPriceAdj + priceAdj;
  }, ttlPriceAdj);
  ttlPriceAdj = fees?.reduce((ttlPriceAdj, fee) => {
    let { usePA, amount, modifier } = fee;
    amount = Number(amount);
    let priceAdj = 0;
    if (usePA) {
      // modifier 1 is % and 2 is flat amount
      priceAdj = modifier === 1 ? (amount / 100) * jobsTotal : amount;
    }
    return ttlPriceAdj + priceAdj;
  }, ttlPriceAdj);
  
  const subTotal = jobsTotal + ttlPriceAdj
  // Conditionally calculate sales tax
  if (sales_tax) {
    salesTax = subTotal * 0.0825;
  }
  
  // Final tally*
  grandTotal = subTotal + salesTax;
  const costTotal = ttlCostTax + ttlCostMaterials + ttlCostLabor;
  const profitTotal = grandTotal - costTotal;

  return {
    jobsTotal,
    priceAdjs,
    grandTotal,
    subTotal,
    ttlPriceAdj,
    salesTax,
    ttlCostTax,
    ttlCostMaterials,
    ttlCostLabor,
    profitTotal,
  };
};

const calcDeposit = ({ deposit, deposit_modifier, optionTotal }) => {
  // console.log("deposit:", deposit);
  if (parseInt(deposit_modifier) === 2) {
    return Number(deposit);
  }
  return (Number(deposit) * optionTotal) / 100;
};

const calcCommissions = ({ salesReps, serviceReps, profit, listServiceReps, jobType, commissions }) => {
  let salesMultiplier, serviceMultiplier, mattMultiplier
  
  if(jobType === 4) {
    salesMultiplier = commissions?.standard_sales
    serviceMultiplier = commissions?.standard_service
  } else {
    salesMultiplier = commissions?.commercial_sales
    serviceMultiplier = commissions?.commercial_service
    mattMultiplier = commissions?.commercial_matt
  }

  // console.log("jobType:", jobType)
  // console.log("commissions:", commissions)
  // console.log("salesMultiplier:", salesMultiplier)
  // console.log("serviceMultiplier:", serviceMultiplier)
  // console.log("mattMultiplier:", mattMultiplier)

  const workCommission = salesReps?.length > 0 ? profit * (serviceMultiplier / 100) : 0;
  const saleCommission = serviceReps?.length > 0 ? profit * (salesMultiplier / 100) : 0;
  const mattCommission = profit * (mattMultiplier / 100)

  const salesRepNames = salesReps?.map((rep) => {
    return listServiceReps?.filter((emp) => emp.id === rep)[0]?.text;
  });
  const serviceRepNames = serviceReps?.map((rep) => {
    return listServiceReps?.filter((emp) => emp.id === rep)[0]?.text;
  });
  
  return { salesRepNames, serviceRepNames, workCommission, saleCommission, mattCommission };
};

export { calcOptionTotal, calcDeposit, calcCommissions };
